import { render } from "./instructor-delete-account.vue?vue&type=template&id=4187c038"
import script from "./instructor-delete-account.vue?vue&type=script&lang=js"
export * from "./instructor-delete-account.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__